export default '/build/43579d96.svg'